import styled from '@emotion/styled'

import { spacing } from 'main/ui'

export const Container = styled.div`
  text-align: center;
`

export const TitleContainer = styled.div`
  margin-bottom: ${spacing.majorScale(12)}px;
  margin-top: ${spacing.majorScale(6)}px;
`
